"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaunaMapper = void 0;
const enums_1 = require("./enums");
class FaunaMapper {
    static mapOrderToLocal(order) {
        this.replaceFields(order);
        this.mapFaunaTimestamp(order);
        this.removeDatakeyFromObjects(order);
        return Object.assign(Object.assign({}, order), enums_1.EnumMapper.mapEnumsRecursively(order));
    }
    static mapFaunaObjectToLocal(object) {
        this.replaceFields(object);
        this.mapFaunaTimestamp(object);
        this.removeDatakeyFromObjects(object);
        return Object.assign({}, enums_1.EnumMapper.mapEnumsRecursively(object));
    }
    static mapFaunaTimestamp(object) {
        this.replaceFields(object, '_ts', 'timestamp');
        const removeTimestampMilliseconds = (object, field) => {
            if (typeof object[field] === 'number') {
                return object[field] / 1000;
            }
            return object[field];
        };
        const mapped = FaunaMapper.recursivelyApplyCallbackOnFields(object, removeTimestampMilliseconds, ['timestamp']);
        return Object.assign({}, mapped);
    }
    static replaceFields(object, oldKey = '_id', newKey = 'id') {
        Object.keys(object).forEach((key) => {
            if (typeof object[key] === 'object' && object[key] !== null) {
                this.replaceFields(object[key], oldKey, newKey);
            }
            if (Array.isArray(object[key])) {
                for (let innerObject of object[key]) {
                    this.replaceFields(innerObject, oldKey, newKey);
                }
            }
        });
        if (object[oldKey]) {
            delete Object.assign(object, { [newKey]: object[oldKey] })[oldKey];
        }
    }
    static deleteFields(object, fields = ['id']) {
        if (Array.isArray(fields)) {
            fields.forEach((field) => {
                if (object === null || object === void 0 ? void 0 : object.hasOwnProperty(field)) {
                    delete object[field];
                }
            });
        }
        Object.keys(object).forEach((key) => {
            if (Array.isArray(object[key])) {
                object[key] = object[key].map((innerObject) => this.deleteFields(innerObject, fields));
            }
            else if (typeof object[key] === 'object' && object[key] !== null) {
                object[key] = Object.assign({}, this.deleteFields(object[key], fields));
            }
        });
        return object;
    }
    static recursivelyApplyCallbackOnFields(object, callback, fields = ['id']) {
        if (Array.isArray(fields)) {
            fields.forEach((field) => {
                if (object === null || object === void 0 ? void 0 : object.hasOwnProperty(field)) {
                    object[field] = callback(object, field);
                }
            });
        }
        Object.keys(object).forEach((key) => {
            if (Array.isArray(object[key])) {
                object[key] = object[key].map((innerObject) => this.recursivelyApplyCallbackOnFields(innerObject, callback, fields));
            }
            else if (typeof object[key] === 'object' && object[key] !== null) {
                object[key] = Object.assign({}, this.recursivelyApplyCallbackOnFields(object[key], callback, fields));
            }
        });
        return object;
    }
    static removeDatakeyFromObjects(object) {
        Object.keys(object).forEach((key) => {
            if (object[key] && object[key].data) {
                object[key] = object[key].data;
            }
            if (object[key] && typeof object[key] === 'object') {
                this.removeDatakeyFromObjects(object[key]);
            }
        });
    }
    static extractRootLevelFlatFieldsFromObject(object) {
        let result = {};
        Object.keys(object).forEach((key) => {
            if (object[key] === null || typeof object[key] === 'undefined') {
                result[key] = object[key];
            }
            if (typeof object[key] !== 'object' && !Array.isArray(object[key])) {
                result[key] = object[key];
            }
        });
        return result;
    }
    static mapFaunaInput(input, deleteFields = ['id', 'timestamp']) {
        const mappedEnums = enums_1.EnumMapper.mapEnumsToStringRecursively(input);
        return this.deleteFields(mappedEnums, deleteFields);
    }
}
exports.FaunaMapper = FaunaMapper;
//# sourceMappingURL=fauna.js.map